import client from './client'

export default {
    findNearest(lat, lon) {
        return client.post('/locci/geo/city/nearest/', { lat, lon })
    },
    findNearby(citySlug) {
        return client.post('/locci/geo/city/nearby/', { city_slug: citySlug })
    },
    findNearbyCoastal(citySlug) {
        return client.post('/locci/geo/city/nearby/', { city_slug: citySlug, is_coastal: true })
    },
    fetchTopCities(citySlug, top) {
        return client.post('/locci/geo/city/top/', { city_slug: citySlug, top: String(top) })
    },
    searchCities(name) {
        return client.post('/locci/geo/city/search/', { name })
    },
    fetchCityDatetime(citySlug) {
        return client.post('/locci/geo/city/datetime/', { city_slug: citySlug })
    },
    fetchWorldClock(cityIds) {
        return client.post('/locci/geo/city/world-clock/', { city_ids: cityIds })
    },
    fetchContinents() {
        return client.get('/locci/geo/continent/')
    },
    fetchCountries(continentSlug) {
        return client.get(`/locci/geo/country/?continent_slug=${continentSlug}`)
    },
    fetchRegions(countrySlug) {
        return client.get(`/locci/geo/region/?country_slug=${countrySlug}`)
    },
    fetchCities(regionCode) {
        return client.get(`/locci/geo/city/?region_slug=${regionCode}`)
    },
    fetchCity(citySlug) {
        return client.get(`/locci/geo/city/${citySlug}/`)
    },
}
